import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DropdownItem } from '../../event/models/dropdown-item';

@Component({
  selector: 'pioneer-dropdown-search',
  templateUrl: './dropdown-search.component.html',
  styleUrls: ['./dropdown-search.component.css']
})
export class DropdownSearchComponent implements OnInit {

  @Input()
  control: FormControl;

  @Input()
  label: string;

  @Input()
  placeholder: string;

  @Input('options')
  set options(options: DropdownItem[]) {
    this._originalOptions = options;
    this.dropdownOptions = options ? [...options] : options;
  }

  @Input()
  controlName: string;

  @Output()
  selected = new EventEmitter<DropdownItem>();

  @ViewChild('searchInputElement')
  searchInputElement: ElementRef;

  dropdownOptions: DropdownItem[];

  displayDropdown = false;

  selectedOption: DropdownItem;

  searchInput = '';

  private _originalOptions: DropdownItem[];

  constructor(protected renderer: Renderer2) { }

  ngOnInit() { }

  iconClick() {
    this.searchInputElement.nativeElement.focus();
  }

  filter() {
    const searchValue = this.searchInput ? this.searchInput.trim().toLowerCase() : '';
    this.dropdownOptions = this._originalOptions.filter((item: DropdownItem) => {
      return  (item.key && item.key.toLowerCase().indexOf(searchValue) >= 0)
              || (item.value && item.value.toLowerCase().search(searchValue) >= 0);
    });
  }

  select(option: DropdownItem) {
    this.searchInputElement.nativeElement.focus();
    this.selectedOption = option;
    if (option) {
      this.control.setValue(option.key);
      this.searchInput = option.value;
    } else {
      this.reset();
    }
    this.closeDropdown();
    this.selected.emit(option);
  }

  reset() {
    this.selectedOption = undefined;
    if (this.control) {
      this.control.setValue('');
    }
    this.searchInput = '';
  }

  closeDropdown() {
    this.searchInput = this.selectedOption ? this.selectedOption.value : '';
    this.dropdownOptions = this._originalOptions ? [...this._originalOptions] : this._originalOptions;
    this.displayDropdown = false;
  }

  toggleDropdown() {
    if (this.displayDropdown) {
      this.closeDropdown();
    } else {
      this.openDropdown();
    }
  }

  inputKeydown() {
    this.displayDropdown = true;
  }

  private openDropdown() {
    this.searchInput = '';
    this.displayDropdown = true;
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/dropdown-search/dropdown-search.component.ts